import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Machine } from 'src/app/shared/models/machine';
import { Proprietaire } from 'src/app/shared/models/proprietaire';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-edit-parametrage-machine',
  templateUrl: './edit-parametrage-machine.component.html',
  styleUrl: './edit-parametrage-machine.component.scss'
})

export class EditParametrageMachineComponent {
  item: Machine = new Machine();
  departementItems: any;
  typeMachinItems: any;
  accessoireItems: any;
  items: any = [];
  etatItems: any;
  photoPreview: string | ArrayBuffer | null = null;
  visible: boolean = false;
  accessoire_checked: any
  position: string = 'center';
  reference: any;
  proprietaire: Proprietaire = new Proprietaire();
  isvisibleProprietaire: boolean = false;

  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private ngxservice: NgxUiLoaderService

  ) { }



  ngOnInit() {
    this.reference = this.localStorage.getUsers().data;
    this.items = this.localStorage.getMachine();
    this.item = this.localStorage.getMachine();
    console.log("this.items", this.items);
    this.photoPreview = this.localStorage.getMachine()?.image;
    this.item.image = null
    
    this.getTypemachine();
  }



  close() {

    this.modalService.dismissAll();
  }
  closeProprietaireModal() {
    if (!this.proprietaire.canSave()) {
      this.isvisibleProprietaire = true;
      this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: this.proprietaire.getErrorMessage() });
      return;

    }
    this.isvisibleProprietaire = false;

  }



  editMachine() {
    // if (!this.item.canSave()) {
    //   this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: this.item.getErrorMessage() });
    //   return;
    // }
    // else {
    if (!this.proprietaire.canSave()) {
      this.position ="left"
      this.isvisibleProprietaire = true;
      this.proprietaire.nom = this.items?.proprietaire?.nom;
      this.proprietaire.prenom = this.items?.proprietaire?.prenom;
      this.proprietaire.telephone = this.items?.proprietaire?.telephone;
      this.proprietaire.email = this.items?.proprietaire?.email;
      this.proprietaire.adresse = this.items?.proprietaire?.adresse;
      return;
    }

    else {
      this.isvisibleProprietaire = false;
      // Récupérer les accessoires sélectionnés
      this.ngxservice.start();

      const accessoiresSelectionnes = this.accessoireItems
        .filter((item: any) => item.accessoire_checked) // Vérifie si la case est cochée
        .map((item: any) => item.id); // Récupère les identifiants des accessoires sélectionnés
      // Créer l'objet FormData
      let formData: FormData = new FormData();
      formData.append('nom', this.item.nom);
      formData.append('numero_serie', this.item.numero_serie);
      formData.append('type_machine_id', this.item.type_machine_id);
      formData.append('type_maintenance', this.item.type_maintenance);
      formData.append('etats_machines_id', this.item.etats_machines_id);
      formData.append('condition_location', this.item.condition_location);
      formData.append('montant', this.item.montant);
      formData.append('user_id', this.reference.reference);

      formData.append('machine_id', this.items.reference);

      // Ajouter les accessoires sous forme de tableau ou de chaîne JSON
      formData.append('accessoires_machines', JSON.stringify(accessoiresSelectionnes));
      if (this.item.image) {
        formData.append('image', this.item.image);

      }

      formData.append('proprietaire[nom]', this.proprietaire.nom);
      formData.append('proprietaire[prenom]', this.proprietaire.prenom);
      formData.append('proprietaire[telephone]', this.proprietaire.telephone);
      formData.append('proprietaire[email]', this.proprietaire.email);
      formData.append('proprietaire[adresse]', this.proprietaire.adresse);


      // Envoyer la requête
      this.paramService.editMachine(formData).subscribe(
        (response: any) => {
          this.ngxservice.stop();
          this.modalService.dismissAll();
          this.messageService.add({
            severity: 'success',
            summary: "AfriCereal",
            detail: response.message,
          });
          this.fecthDataService.notifySeriviceCreated();
        },
        (error: any) => {
          this.ngxservice.stop();
          this.messageService.add({
            severity: 'error',
            summary: "AfriCereal",
            detail: error,
          });
        }
      );
    }

  }
  //}

  showDialog(position: string) {
    this.position = position;
    this.visible = true;
  }
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.item.image = file;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.photoPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  getTypemachine() {
    this.paramService.getTypeMachine().subscribe(
      (response: any) => {
        this.typeMachinItems = response.data;
        console.log("typeMachinItems", this.typeMachinItems);
        this.getAccessoire();
      },

      (error: any) => {
        console.log("erreur est survenu", error);

      }
    )
  }

  getAccessoire() {
    this.paramService.getAccessoire().subscribe(
      (response: any) => {
        this.accessoireItems = response.data;

        // Comparer et marquer les accessoire comme sélectionnées si elles existent dans les accesoire
        this.accessoireItems.forEach(item => {
          // Vérifier si l'accessoire fait partie des accessoires de la machine
          const matchingAccessoire = this.items?.accessoires_machine?.find(accessoire =>
            String(accessoire.accessoire_id) === String(item.id) // Comparaison sécurisée
          );

          // Marquer la case comme cochée ou non
          item.accessoire_checked = !!matchingAccessoire; // true si trouvé, false sinon
        });

        console.log("Liste des accessoires :", this.accessoireItems);
        this.getEtat(); // Si cette méthode est nécessaire pour un autre traitement
      },
      (error: any) => {
        console.error("Erreur lors de la récupération des accessoires :", error);
      }
    );
  }

  getEtat() {
    this.paramService.getEtat().subscribe(
      (response: any) => {
        this.etatItems = response.data;
        console.log("etatItems", this.etatItems);

      },

      (error: any) => {
        console.log("erreur est survenu", error);

      }
    )
  }

  onOkClick(): void {
    console.log(this.accessoireItems);

    this.visible = false;
  }

}
